import {
  cateringModulePermission,
  accountingModule,
  integrationModule,
  inventoryModule,
  marketingModule,
  menuBoardModule,
  menuManagerModule,
  paymentModule,
  payrollModule,
  reportsModulePermission,
  performanceSummaryReportModulePermission,
  thirdPartyReportModulePermission,
  refundReportModulePermission,
  dealsReportModulePermission,
  giftCardReportModulePermission,
  discountReportModulePermission,
  merchantReportModulePermission,
  employeeTimeOffAdminModulePermission,
  roleAndPermissionsModule,
  settingsModule,
  tipsModule,
  websiteModule,
} from '../DashboardModule/modulepermissions';

export const tenderCashDrawerFeatures = [
  paymentModule['tenders-visible'],
  paymentModule['tenders-create'],
  paymentModule['tenders-read'],
  paymentModule['tenders-edit'],
  paymentModule['tenders-delete'],
  paymentModule['cash-drawer-visible'],
  paymentModule['cash-drawer-create'],
  paymentModule['cash-drawer-read'],
  paymentModule['cash-drawer-edit'],
  paymentModule['cash-drawer-delete'],
];
export const roleAndPermissionsModulePermissions = [
  roleAndPermissionsModule['roles-permissions-visible-module'],
  roleAndPermissionsModule['roles-permissions-visible'],
  roleAndPermissionsModule['roles-permissions-create'],
  roleAndPermissionsModule['roles-permissions-read'],
  roleAndPermissionsModule['roles-permissions-edit'],
  roleAndPermissionsModule['roles-permissions-delete'],
];
export const integrationModulePermissions = [
  integrationModule['integrations-visible-module'],
  integrationModule['integrations-visible'],
  integrationModule['integrations-create'],
  integrationModule['integrations-read'],
  integrationModule['integrations-edit'],
  integrationModule['integrations-delete'],
];
export const tipsPoolingModulePermissions = [
  tipsModule['tips-management-visible'],
  tipsModule['tips-pooling-visible'],
  tipsModule['tips-pooling-create'],
  tipsModule['tips-pooling-read'],
  tipsModule['tips-pooling-edit'],
  tipsModule['tips-pooling-delete'],
];

export const payrollModulePermissions = [
  payrollModule['payroll-visible'],
  payrollModule['onboarding-visible'],
  payrollModule['onboarding-create'],
  payrollModule['onboarding-read'],
  payrollModule['onboarding-edit'],
  payrollModule['onboarding-delete'],
  payrollModule['setup-visible'],
  payrollModule['setup-create'],
  payrollModule['setup-read'],
  payrollModule['setup-edit'],
  payrollModule['setup-delete'],
  payrollModule['benefits-visible'],
  payrollModule['benefits-read'],
  payrollModule['benefits-create'],
  payrollModule['benefits-edit'],
  payrollModule['benefits-delete'],
];

export const settingsModulePermission = [
  settingsModule['settings-visible'],
  settingsModule['receipt-settings-visible'],
  settingsModule['receipt-settings-create'],
  settingsModule['receipt-settings-read'],
  settingsModule['receipt-settings-edit'],
  settingsModule['receipt-settings-delete'],
  settingsModule['business-hours-visible'],
  settingsModule['business-hours-create'],
  settingsModule['business-hours-read'],
  settingsModule['business-hours-edit'],
  settingsModule['business-hours-delete'],
];
export const reviewManagementFeaturePermission = [
  marketingModule['review-management-visible'],
  marketingModule['review-management-create'],
  marketingModule['review-management-read'],
  marketingModule['review-management-edit'],
  marketingModule['review-management-delete'],
];

export const visibleCheckPermissions = [
  paymentModule['sales-tax-visible'],
  paymentModule['comps-visible'],
  paymentModule['service-charge-visible'],
  menuManagerModule['Item-visible'],
  menuManagerModule['menu-visible'],
  menuManagerModule['category-visible'],
  menuManagerModule['modifier-group-visible'],
  menuManagerModule['modifier-visible'],
  menuManagerModule['tags-&-allergens-visible'],
  menuManagerModule['modifier-option-visible'],
  marketingModule['brandbook-visible'],
  marketingModule['guestbook-visible'],
  marketingModule['campaigns-visible'],
  marketingModule['dashboard-visible'],
  marketingModule['deals-visible'],
  marketingModule['gift-cards-visible'],
  marketingModule['website-visible'],
  marketingModule['spotlights-visible'],
  marketingModule['guest-segments-visible'],
  marketingModule['guest-spend-visible'],
  marketingModule['journeys-visible'],
  marketingModule['loyalty-visible'],
  inventoryModule['ingredients-visible'],
  inventoryModule['invoices-visible'],
  inventoryModule['non-ingredients-visible'],
  inventoryModule['orders-visible'],
  inventoryModule['recipes-visible'],
  inventoryModule['storage-areas-visible'],
  inventoryModule['vendors-visible'],
  websiteModule['website-announcements-visible'],
  websiteModule['website-builder-visible'],
  websiteModule['website-seo-visible'],
  websiteModule['website-templates-visible'],
];
export const websiteModulePermission = [
  websiteModule['website-visible'],
  websiteModule['website-announcements-visible'],
  websiteModule['website-announcements-create'],
  websiteModule['website-announcements-read'],
  websiteModule['website-announcements-edit'],
  websiteModule['website-announcements-delete'],
  websiteModule['website-builder-visible'],
  websiteModule['website-builder-create'],
  websiteModule['website-builder-read'],
  websiteModule['website-builder-edit'],
  websiteModule['website-builder-delete'],
  websiteModule['website-seo-visible'],
  websiteModule['website-seo-create'],
  websiteModule['website-seo-read'],
  websiteModule['website-seo-edit'],
  websiteModule['website-seo-delete'],
  websiteModule['website-templates-visible'],
  websiteModule['website-templates-create'],
  websiteModule['website-templates-read'],
  websiteModule['website-templates-edit'],
  websiteModule['website-templates-delete'],
];

//Report permissions consistence for owner manager gm shiftAssistant Role
export const reportModuleFeaturePermissions = [
  reportsModulePermission['reports-visible-module'],
  reportsModulePermission['reports-visible'],
  reportsModulePermission['reports-create'],
  reportsModulePermission['reports-read'],
  reportsModulePermission['reports-edit'],
  reportsModulePermission['reports-delete'],
];

export const menuBoardPermission = [
  menuBoardModule['menu-board-visible'],
  menuBoardModule['playlists-visible'],
  menuBoardModule['playlists-create'],
  menuBoardModule['playlists-delete'],
  menuBoardModule['playlists-edit'],
  menuBoardModule['playlists-read'],
  menuBoardModule['screens-visible'],
  menuBoardModule['screens-create'],
  menuBoardModule['screens-delete'],
  menuBoardModule['screens-edit'],
  menuBoardModule['screens-read'],
];

export const reportNewFeaturesPermissions = [
  reportsModulePermission['net-sales-visible'],
  reportsModulePermission['net-sales-create'],
  reportsModulePermission['net-sales-edit'],
  reportsModulePermission['net-sales-read'],
  reportsModulePermission['sales-summary-visible'],
  reportsModulePermission['sales-summary-create'],
  reportsModulePermission['sales-summary-edit'],
  reportsModulePermission['sales-summary-read'],
  reportsModulePermission['timecards-visible'],
  reportsModulePermission['timecards-create'],
  reportsModulePermission['timecards-edit'],
  reportsModulePermission['timecards-read'],
  reportsModulePermission['payroll-history-visible'],
  reportsModulePermission['payroll-history-create'],
  reportsModulePermission['payroll-history-edit'],
  reportsModulePermission['payroll-history-read'],
];

export const payrollSummaryReportPermissions = [
  reportsModulePermission['payroll-summary-report-visible'],
  reportsModulePermission['payroll-summary-report-read'],
];

export const allReportsAccessPermissions = [
  // Existing reports (visible + read only)
  reportsModulePermission['sales-summary-visible'],
  reportsModulePermission['sales-summary-read'],
  reportsModulePermission['net-sales-visible'],
  reportsModulePermission['net-sales-read'],
  reportsModulePermission['timecards-visible'],
  reportsModulePermission['timecards-read'],
  reportsModulePermission['payroll-history-visible'],
  reportsModulePermission['payroll-history-read'],
  // New reports (visible + read only)
  reportsModulePermission['labor-cost-visible'],
  reportsModulePermission['labor-cost-read'],
  reportsModulePermission['overtime-visible'],
  reportsModulePermission['overtime-read'],
  reportsModulePermission['employee-productivity-visible'],
  reportsModulePermission['employee-productivity-read'],
  reportsModulePermission['tip-pooling-report-visible'],
  reportsModulePermission['tip-pooling-report-read'],
  reportsModulePermission['break-compliance-visible'],
  reportsModulePermission['break-compliance-read'],
  reportsModulePermission['menu-summary-visible'],
  reportsModulePermission['menu-summary-read'],
  // Temporarily hidden - Marketing Reports (2026)
  // reportsModulePermission['gift-card-visible'],
  // reportsModulePermission['gift-card-read'],
  // reportsModulePermission['loyalty-visible'],
  // reportsModulePermission['loyalty-read'],
  // reportsModulePermission['deals-visible'],
  // reportsModulePermission['deals-read'],
];
export const refundReportPermissions = [
  refundReportModulePermission['refund-report-visible'],
  refundReportModulePermission['refund-report-create'],
  refundReportModulePermission['refund-report-edit'],
  refundReportModulePermission['refund-report-read'],
];

export const webSiteNewFeaturesPermissions = [
  websiteModule['forms-visible'],
  websiteModule['forms-create'],
  websiteModule['forms-read'],
  websiteModule['forms-edit'],
  websiteModule['forms-delete'],
  websiteModule['overview-visible'],
  websiteModule['overview-create'],
  websiteModule['overview-read'],
  websiteModule['overview-edit'],
  websiteModule['overview-delete'],
];

export const cateringDashboardDefaultRolePermission = [
  cateringModulePermission['catering-visible'],
  cateringModulePermission['dashboard-create'],
  cateringModulePermission['dashboard-read'],
  cateringModulePermission['dashboard-edit'],
  cateringModulePermission['invoice-management-create'],
  cateringModulePermission['invoice-management-read'],
  cateringModulePermission['invoice-management-edit'],
  cateringModulePermission['package-configuration-create'],
  cateringModulePermission['package-configuration-read'],
  cateringModulePermission['package-configuration-edit'],
  cateringModulePermission['package-configuration-delete'],
  cateringModulePermission['email-templates-read'],
];

export const settingsPosFeaturePermissions = [
  settingsModule['pos-visible'],
  settingsModule['pos-create'],
  settingsModule['pos-read'],
  settingsModule['pos-edit'],
  settingsModule['pos-delete'],
];

export const financialStatementFeaturePermissions = [
  accountingModule['financial-statement-visible'],
  accountingModule['financial-statement-create'],
  accountingModule['financial-statement-read'],
  accountingModule['financial-statement-edit'],
  accountingModule['financial-statement-delete'],
];

export const performanceSummaryReportPermissions = [
  performanceSummaryReportModulePermission['performance-summary-report-visible'],
  performanceSummaryReportModulePermission['performance-summary-report-create'],
  performanceSummaryReportModulePermission['performance-summary-report-edit'],
  performanceSummaryReportModulePermission['performance-summary-report-read'],
];

export const merchantReportPermissions = [
  merchantReportModulePermission['merchant-report-visible'],
  merchantReportModulePermission['merchant-report-create'],
  merchantReportModulePermission['merchant-report-edit'],
  merchantReportModulePermission['merchant-report-read'],
];

export const thirdPartyReportPermissions = [
  thirdPartyReportModulePermission['third-party-order-report-visible'],
  thirdPartyReportModulePermission['third-party-order-report-create'],
  thirdPartyReportModulePermission['third-party-order-report-edit'],
  thirdPartyReportModulePermission['third-party-order-report-read'],
];

export const dealsReportPermissions = [
  dealsReportModulePermission['deals-report-visible'],
  dealsReportModulePermission['deals-report-read'],
  dealsReportModulePermission['deals-report-edit'],
  dealsReportModulePermission['deals-report-delete'],
];

export const giftCardReportPermissions = [
  giftCardReportModulePermission['gift-card-report-visible'],
  giftCardReportModulePermission['gift-card-report-read'],
  giftCardReportModulePermission['gift-card-report-edit'],
  giftCardReportModulePermission['gift-card-report-delete'],
];

export const discountReportPermissions = [
  discountReportModulePermission['discount-report-visible'],
  discountReportModulePermission['discount-report-create'],
  discountReportModulePermission['discount-report-edit'],
  discountReportModulePermission['discount-report-read'],
];

export const cateringRemainingFeaturesPermissions = [
  cateringModulePermission['payment-configuration-visible'],
  cateringModulePermission['payment-configuration-create'],
  cateringModulePermission['payment-configuration-read'],
  cateringModulePermission['payment-configuration-edit'],
  cateringModulePermission['payment-configuration-delete'],
  cateringModulePermission['email-inbox-visible'],
  cateringModulePermission['email-inbox-create'],
  cateringModulePermission['email-inbox-read'],
  cateringModulePermission['email-inbox-edit'],
  cateringModulePermission['email-inbox-delete'],
  cateringModulePermission['calendar-visible'],
  cateringModulePermission['calendar-create'],
  cateringModulePermission['calendar-read'],
  cateringModulePermission['calendar-edit'],
  cateringModulePermission['calendar-delete'],
];
export const employeeTimeOffAdminPermissions = [
  employeeTimeOffAdminModulePermission['time-off-visible-module'],
  employeeTimeOffAdminModulePermission['time-off-policy-visible'],
  employeeTimeOffAdminModulePermission['time-off-policy-create'],
  employeeTimeOffAdminModulePermission['time-off-policy-edit'],
  employeeTimeOffAdminModulePermission['time-off-policy-read'],
  employeeTimeOffAdminModulePermission['time-off-allocation-visible'],
  employeeTimeOffAdminModulePermission['time-off-allocation-create'],
  employeeTimeOffAdminModulePermission['time-off-allocation-edit'],
  employeeTimeOffAdminModulePermission['time-off-allocation-read'],
  employeeTimeOffAdminModulePermission['time-off-leave-overview-visible'],
  employeeTimeOffAdminModulePermission['time-off-leave-overview-create'],
  employeeTimeOffAdminModulePermission['time-off-leave-overview-edit'],
  employeeTimeOffAdminModulePermission['time-off-leave-overview-read'],
  employeeTimeOffAdminModulePermission['time-off-requests-feature-visible'],
  employeeTimeOffAdminModulePermission['time-off-requests-feature-create'],
  employeeTimeOffAdminModulePermission['time-off-requests-feature-edit'],
  employeeTimeOffAdminModulePermission['time-off-requests-feature-read'],
  employeeTimeOffAdminModulePermission['time-off-settings-visible'],
  employeeTimeOffAdminModulePermission['time-off-settings-create'],
  employeeTimeOffAdminModulePermission['time-off-settings-edit'],
  employeeTimeOffAdminModulePermission['time-off-settings-read'],
];
